import { AbstractControl, ValidatorFn } from '@angular/forms';

export function crossFieldLowerHigherValidator(
  lowerControlName: string,
  higherControlName: string,
  allowEqual = false
): ValidatorFn {
  return (group: AbstractControl) => {
    const lowerControl = group.get(lowerControlName);
    const higherControl = group.get(higherControlName);
    if (!lowerControl) {
      console.warn('Field doesnt exist ', lowerControlName);
      return null;
    }
    if (!higherControl) {
      console.warn('Field doesnt exist ', higherControlName);
      return null;
    }

    if (
      (!lowerControl.value && lowerControl.value !== 0) ||
      (!higherControl.value && higherControl.value !== 0)
    ) {
      return null;
    }

    // Determine validation rules based on allowEqual parameter
    const isInvalid = allowEqual
      ? higherControl.value < lowerControl.value
      : higherControl.value <= lowerControl.value;

    const errorType = allowEqual ? 'OrEqual' : '';

    if (isInvalid) {
      // Add validation errors
      lowerControl.setErrors({
        ...lowerControl.errors,
        [`lower${errorType}`]: true,
      });
      higherControl.setErrors({
        ...higherControl.errors,
        [`higher${errorType}`]: true,
      });
    } else {
      // Clear specific validation errors if they exist
      clearSpecificError(lowerControl, `lower${errorType}`);
      clearSpecificError(higherControl, `higher${errorType}`);
    }

    // Clear errors completely if no errors remain
    resetErrorsIfEmpty(lowerControl);
    resetErrorsIfEmpty(higherControl);

    return null;
  };

  // Helper functions
  function clearSpecificError(
    control: AbstractControl,
    errorKey: string
  ): void {
    const errors = control.errors;
    if (errors && errors[errorKey]) {
      delete errors[errorKey];
      control.setErrors(errors);
    }
  }

  function resetErrorsIfEmpty(control: AbstractControl): void {
    if (!Object.keys(control.errors ?? {}).length) {
      control.setErrors(null);
    }
  }
}
